import { backendServices } from 'common';
import {
    BuildSimDocumentArgs,
    SIM_DOCUMENT_CLASS,
    SimSubmissionContext,
    buildSimDocumentViewModel,
} from '../../_shared/simDocumentVM';
import { TaxDetailsFormViewModel } from './TaxDetailsFormViewModel';

/**
 * Builds the HeaderInfo payload for the W-9 SIM document.
 *
 * Paths under BusinessDocument.SIMDocument.HeaderInfo:
 *   - TIN        -> HeaderInfo.TIN
 *   - VATNumber  -> HeaderInfo.VAT
 */
function taxDetailsFormToHeaderInfo(form: TaxDetailsFormViewModel): Record<string, string | undefined> {
    return {
        TIN: form.TIN,
        VAT: form.VATNumber,
    };
}

/**
 * Convert the Tax Details form into a full DocumentViewModel ready to
 * POST to /Document.
 *
 * The skeleton is whatever GET /Document/Skeleton returned for
 * BusinessDocType=SIMDocument, documentClass=1.
 */
export function convertTaxDetailsFormToVM(
    form: TaxDetailsFormViewModel,
    skeleton: BuildSimDocumentArgs['skeleton'],
    context: SimSubmissionContext,
    simDocumentTypeId: number | null,
    scheduleDescription?: string | null,
    simRequestId?: number
): backendServices.ViewModels.DocumentViewModel {
    return buildSimDocumentViewModel({
        skeleton,
        context,
        documentClass: SIM_DOCUMENT_CLASS.W9,
        description: scheduleDescription || 'W-9 Tax Details',
        documentType: 'W-9',
        headerInfo: taxDetailsFormToHeaderInfo(form),
        simDocumentTypeId,
        simRequestId,
    });
}
